import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/external-api/api.service";
import {IApplicationParametersState} from "../state/application-parameters/application-parameters.state";

import {ConfigurationManager} from "../../configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {

  constructor(private apiService: ApiService, private configurationManager: ConfigurationManager) { }

  getNomenclatureHierarchyList(accessToken: string, datasourceId?: string){
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/nomenclaturehierarchylist', {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    });
  }
  getOrganisationHierarchyList(accessToken: string, datasourceId?: string){
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/organizationhierarchylist', {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    });
  }

  getNomenclatureHierarchy(accessToken: string, hierarchyId?: string, hierarchyLevel?: string, datasourceId?: string){



    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/nomenclaturehierarchy', {
      'access_token':accessToken,
      'access-token':accessToken,
      'hier_id': hierarchyId === undefined || hierarchyId === null?'':hierarchyId,
      'hier_level': hierarchyLevel === undefined || hierarchyLevel === null?'':hierarchyLevel,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    });

  }
  getOrganizationHierarchy(accessToken: string, hierarchyId?: string, hierarchyLevel?: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'hier_id':  hierarchyId === undefined || hierarchyId === null?'':hierarchyId,
      'hier_level': hierarchyLevel === undefined || hierarchyLevel === null?'':hierarchyLevel,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    if (hierarchyId!== undefined && hierarchyId !== null) {
      param.hier_id = hierarchyId;
    }
    if (hierarchyLevel!== undefined && hierarchyLevel !== null) {
      param.hier_level = hierarchyLevel;
    }

    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/organizationhierarchy', param);

  }
  getStores(accessToken: string, hierarchyId?: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'hier_id':  hierarchyId === undefined || hierarchyId === null?'':hierarchyId,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/stores', param);

  }
  getVendors(accessToken: string, param: IApplicationParametersState){
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/vendors', {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid': param.selectedDatasourcePartyId
    });

  }
  getFinDepartments(accessToken: string, param: IApplicationParametersState){
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/findepartment', {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid': param.selectedDatasourcePartyId
    });
  }

  getArticles(accessToken: string, param: IApplicationParametersState){
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/items?limit=100&offset=0', {
      'access_token':accessToken,
      'access-token':accessToken,
      'hier_id': '',
      'datasourcepartyid': param.selectedDatasourcePartyId
    });

  }

  getOsaIncidentTypes(accessToken: string, datasourceId?: string){
    return this.apiService.get(this.configurationManager.getApiUrl('apiOSAUrl') + '/incidenttypes', {
      'access-token':accessToken,
      'access_token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    });
  }

  getTypes(accessToken: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/types', param);

  }

  getHierarchyList(accessToken: string, typeCode: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/types/' + typeCode + '/hierarchy', param);

  }
  getHierarchyLevels(accessToken: string, typeCode: string, hierCode: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/types/' + typeCode + '/hierarchy/'+ hierCode + '/levels', param);

  }
  getHierarchyDetail(accessToken: string, typeCode: string, hierCode: string, levelCode: string, datasourceId?: string){
    const param = {
      'access_token':accessToken,
      'access-token':accessToken,
      'datasourcepartyid':datasourceId === undefined || datasourceId === null?'':datasourceId
    };
    return this.apiService.get(this.configurationManager.getApiUrl('apiDict') + '/types/' + typeCode + '/hierarchy/'+ hierCode + '/levels/'+ levelCode + '/elements?limit=100000', param);

  }
}
